<template>
  <div class="navbar z-20 relative bg-white border-blue-500 border-t-4">
    <div class="relative z-20 shadow-xs">
      <div class="max-w-full flex justify-between items-center pr-2 pl-4 lg:pl-8 md:justify-start md:space-x-4">
        <!-- logo -->
        <div class="flex h-12 items-center space-x-4 truncate">
          <!-- Logo image -->
          <router-link to="/" class="w-48">
            <img v-if="loadingLogoAttempts < 2" class="h-auto max-h-12 m-auto" alt="" :src="logoUrl" @error="replaceWithDefault" />
          </router-link>
          <!-- Application title -->
          <router-link to="/" class="home">
            <span class="text-2xl hover:text-blue-500 uppercase space-x-0">
              <span class="font-semibold">{{ title }}</span
              ><span class="">{{ title2 }}</span>
            </span>
          </router-link>
        </div>

        <!-- Menu items -->
        <div class="hidden md:flex-1 md:flex md:items-center md:justify-between">
          <nav class="flex space-x-4 ml-2">
            <!-- @slot Slot where you can include MenuDropdown components. Shows up to the left of the navbar title and logo. -->
            <slot />
          </nav>
          <div class="flex items-center space-x-4">
            <!-- @slot Custom component to include on the right side of the navbar (before the profile image). -->
            <slot name="navbarRight"></slot>
            <navbar-profile>
              <slot name="profileExtras"></slot>
            </navbar-profile>
          </div>
        </div>

        <!-- mobile hamburger menu -->
        <div class="-mr-2 -my-2 md:hidden">
          <button
            type="button"
            @click="showMobileMenu = !showMobileMenu"
            class="inline-flex items-center justify-center p-2 rounded-md text-gray-400 hover:text-gray-500 hover:bg-gray-50 focus:outline-none focus:bg-gray-100 focus:text-gray-500 transition duration-150 ease-in-out"
          >
            <svg v-if="!showMobileMenu" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16" />
            </svg>
            <svg v-else class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>

        <!--  -->
      </div>
    </div>

    <!-- Mobile menu, show/hide based on mobile menu state. -->
    <menu-mobile :show="showMobileMenu">
      <navbar-profile />
      <hr />
      <slot name="navbarRight"></slot>
      <hr />
      <slot />
    </menu-mobile>
  </div>
</template>

<script>
import MenuMobile from './MenuMobile.vue'
import NavbarProfile from './NavbarProfile.vue'

export default {
  components: {
    MenuMobile,
    NavbarProfile
  },
  props: {
    /**
     * Title of navbar in bold.
     */
    title: {
      type: String,
      default: ''
    },
    /**
     * Second part of title NOT in bold.
     */
    title2: {
      type: String,
      default: ''
    },
    /**
     * Station name for logo
     */
    station: {
      type: String
    }
  },
  data() {
    return {
      openMenu: '',
      currentMenu: '',
      closeMenu: null,
      showMobileMenu: false,
      isMobile: false,
      loadingLogoAttempts: 0
    }
  },
  computed: {
    logoUrl() {
      if (this.station) return `//cdn-ext.scrippsnet.com/img/logos/${this.station}.png`
      return ''
    }
  },
  methods: {
    replaceWithDefault(event) {
      this.loadingLogoAttempts += 1
      event.target.src = '//cdn-ext.scrippsnet.com/img/worklife/scripps-logo-horizontal.png'
    },
    showMenu(menu) {
      clearTimeout(this.closeMenu)
      this.openMenu = menu
    },
    hideMenu() {
      // only hide menu if the cursor is not over the menu
      this.closeMenu = setTimeout(() => {
        if (this.currentMenu.length < 1) {
          this.openMenu = ''
          this.currentMenu = ''
        }
      }, 200)
    },
    enterMenu(menu) {
      this.currentMenu = menu
    },
    leaveMenu() {
      this.currentMenu = ''
      this.hideMenu()
    }
  },
  watch: {
    $route(to, from) {
      this.showMobileMenu = false
    }
  }
}
</script>

<style lang="postcss" scoped>
div.navbar >>> .menu a.router-link-active:not(.home),
div.navbar >>> .menu a.router-link-exact-active {
  @apply text-blue-500 border-b border-blue-400;
  margin-bottom: -1px;
}
</style>
